import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
}                                from '@angular/core';
import { VerticalAlignmentEnum } from '@models/common.model';
import { CheckboxSizeEnum }      from '@shared/components/checkbox/checkbox.model';
import { SvgTypeEnum }           from '@shared/components/svg/svg.model';

@Component( {
	selector: 'app-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: [ './checkbox.component.scss' ]
} )
export class CheckboxComponent implements OnInit {
	private _size: CheckboxSizeEnum = CheckboxSizeEnum.MEDIUM;

	protected readonly verticalAlignmentEnum = VerticalAlignmentEnum;
	protected readonly svgTypeEnum = SvgTypeEnum;

	public checkboxSizeClass: string;
	public labelStyleClassView: string;

	@Input() checked: boolean;
	@Input() disabled: boolean;
	@Input() label: string;
	@Input() labelStyleClass = '';
	@Input() labelUseInnerHtml = false;
	@Input() showLoader = false;

	@Input() set size( size: CheckboxSizeEnum ) {
		this._size = size ?? CheckboxSizeEnum.MEDIUM;
		this.checkboxSizeClass = `checkbox-size--${ this._size }`;
	}

	@Input() verticalAlignment: VerticalAlignmentEnum = VerticalAlignmentEnum.CENTER;

	@Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	ngOnInit() {
		this.checkboxSizeClass = `checkbox-size--${ this._size }`;
		this.labelStyleClassView = `d-inline-flex col-auto ms-2 label label-${ this.checkboxSizeClass } ${ this.labelStyleClass }`;
	}

	onClick(): void {
		if ( this.disabled ) { return; }
		this.checked = !this.checked;
		this.checkedChange.emit( this.checked );
	}
}
